// Deriva a origem ("auto" | "manual") a partir do campo `source` (ou de um
// booleano). Para registros ANTIGOS sem `source`, infere pelo padrão de e-mail.

const AUTO_SOURCES = new Set(["email", "system", "sistema", "api", "worker", "auto"]);

// Conta(s) do worker de e-mail (abertura automática). Ação feita por elas = robô.
export function isAutoActor(name) {
  const n = (name || "").toString().trim().toLowerCase();
  return !!n && n.includes("suporteti");
}

export function fromSource(source, fallbackAuto = false) {
  const s = (source || "").toString().trim().toLowerCase();
  if (s === "manual") return "manual";
  if (AUTO_SOURCES.has(s)) return "auto";
  return fallbackAuto ? "auto" : "manual";
}

// Origem de um EVENTO (histórico/comentário): usa o source; se não houver,
// infere pelo ATOR (worker de e-mail = automático).
export function eventOrigin(source, actor) {
  const s = (source || "").toString().trim().toLowerCase();
  if (s === "manual") return "manual";
  if (AUTO_SOURCES.has(s)) return "auto";
  return isAutoActor(actor) ? "auto" : "manual";
}

// Origem de um CHAMADO. Usa `source`; se não houver (chamado antigo), infere
// pelo assunto/participantes (RE:, e-ref:, [#123], "is ready", tem Para/CC).
export function ticketOrigin(t) {
  const s = (t?.source || "").toString().trim().toLowerCase();
  if (s === "manual") return "manual";
  if (AUTO_SOURCES.has(s)) return "auto";
  const title = t?.title || "";
  if (t?.participant_emails) return "auto";
  if (/^\s*(RE|RES|ENC|FWD|FW|AW|SV)\s*:/i.test(title)) return "auto";
  if (/e-ref:|\[#\s*\d+\]|is ready|ticket\s*#?\s*\d+/i.test(title)) return "auto";
  return "manual";
}
